export default __webpack_public_path__ + "static/media/SAL6.f37dace4.jpg";